import { IncomingMessage } from 'http';
const qs = require('qs');

import { baseConfig } from '../api';

export const buyListConfig = (userId: { userId: string }) => 
    baseConfig().post('/api/user/getBuyList', qs.stringify(userId));

export const currencyData = () => 
    baseConfig().get('/api/user/getCurrency');